/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */

document.addEventListener('DOMContentLoaded', function () {
    // 判断是否为移动端
    function isMobile() {
        return document.body.clientWidth <= 1060;
    }
    let spImgList = [
        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/blue.png?v=1774613383',
        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/green.png?v=1774613383',
        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/blue-head.png?v=1774613969',
        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/green-head.png?v=1774613968'
    ]

    let sp_price1 = 9.99
    let sp_price2 = 19.89


    // 跳转支付页面
    $(document).on('click', '.sp-btn-style', function () {
        let num = $('#calcNumber').val()
        window.location.href = '/cart/' + getCur().id + ':' + num
    })
    let prods = window.product
    function getCur() {
        let color = $('#sp-color div.active').attr('data-val')
        let size = $('#sp-qty div.active').attr('data-val')
        let flat = $('#sp-pro div.active').attr('data-val')
        return prods.filter(
            item =>
                item.option1 == color
                && item.option2 == size
            && item.option3 == flat
        )[0]
    }

    function changePrice() {
        let num = $('#calcNumber').val()
        let price = ((getCur().price * num) / 100).toFixed(2)
        let compare = ((getCur().compare_at_price * num) / 100).toFixed(2)
        // price = (price + '').replace('.', ',')
        // compare = (compare + '').replace('.', ',')
        $('#sp_price1').html(price)
        $('#sp_price2').html(compare)
        let off_font =
            100 - Math.ceil((getCur().price / getCur().compare_at_price) * 100)
        $('.sp_product_part .sp-price-group .off-font').html(off_font)
    }

    function calcTotal(price, num) {
        let result = Number(price) * Number(num)
        return result.toFixed(2)
    }
    $('.sp-reduce').click(function () {
        let input = $(this).siblings('input')[0]
        let num = Number(input.value) - 1
        if (num > 0) {
            input.value = num
        }
        // $("#sp_price1").html(calcTotal(sp_price1, input.value));
        // $("#sp_price2").html(calcTotal(sp_price2, input.value));
        changePrice()
    })
    $('.sp-add').click(function () {
        let input = $(this).siblings('input')[0]
        let num = Number(input.value) + 1
        input.value = num
        // $("#sp_price1").html(calcTotal(sp_price1, input.value));
        // $("#sp_price2").html(calcTotal(sp_price2, input.value));

        changePrice()
    })
    var _index = 0
    // 颜色组和样式组的选择器
    const colorGroup = '#sp-color';
    const styleGroup = '#sp-qty';
    const numGroup = '#sp-pro';


    $('.sp-option').click(function () {
        let tips=['x1','x2','x4']
        // 切换当前选项的 active 状态
        $(this).addClass('active').siblings().removeClass('active');

        // 获取当前选中的颜色索引和样式索引
        const colorIndex = $(`${colorGroup} .sp-option.active`).index();
        const styleIndex = $(`${styleGroup} .sp-option.active`).index();
        const numIndex = $(`${numGroup} .sp-option.active`).index();

        $("#num-tips").text(tips[numIndex])

        // 计算图片索引（假设图片顺序：先按颜色排列，再按样式排列）
        const colorCount = $(`${colorGroup} .sp-option`).length;
        const imgIndex = colorIndex + (styleIndex * colorCount);

        // 更新产品图片（使用正确的图片类名 .sp-img-m）
        $('.sp-img-inner .sp-img-m')
            .removeClass('active')
            .eq(imgIndex)
            .addClass('active');

        // 更新价格
        if (typeof changePrice === 'function') {
            changePrice();
        }
    });
    $(".addCart").click(function () {
        console.log("加购");
        const data = {
            id: getCur().id,
            quantity: $('#calcNumber').val(),
        };
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            success: function () {
                $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
                    $('.cardNum').html(result.item_count);
                    $('.cardNum').removeClass('sp-gray');
                });
            },
            dataType: 'json',
        });

        var imgs = $(".sp-img-inner .active");
        imgs.each(function () {
            var $img = $(this);
            var flyer = $img[0].cloneNode(true);
            flyer.classList.add("sp_clone");

            $(".product-part").append(flyer);

            // 获取源图片相对于视口的位置
            var imgRect = $img[0].getBoundingClientRect();
            $(flyer).css({
                position: "fixed",
                top: imgRect.top,
                left: imgRect.left,
                width: imgRect.width,
                height: imgRect.height,
                "z-index": 99,
                background: "#e7e9ef",
            });

            // 获取目标购物车的位置
            var finish, targetRect;
            if (isMobile()) {
                finish = $(".sp-btn-style2.sp-mobile .sp-cart");
            } else {
                finish = $(".sp-pc .sp-cart");
            }
            if (finish.length) {
                targetRect = finish[0].getBoundingClientRect();
            } else {
                targetRect = { top: 0, left: 0 };
            }

            $(flyer).animate(
                {
                    top: targetRect.top,
                    left: targetRect.left,
                    width: 50,
                    height: 50,
                    opacity: 0.4,
                },
                500,
                "linear",
                function () {
                    $(this).animate(
                        {
                            width: 0,
                            height: 0,
                            opacity: 0,
                        },
                        0,
                        function () {
                            $(this).detach();
                        }
                    );
                }
            );
        });
    });

    $(function () {
        // 判断是否为移动端
        function isMobile() {
            return document.body.clientWidth <= 1060;
        }

        // 购物车加购动效
        $(".cart-btn").click(function () {
            $(this).children("img").addClass("on");
            if (isMobile()) {
                $(".sp-mobile .sp-cart .num").show();
                $(".sp-mobile .sp-cart").addClass("on");
                setTimeout(function () {
                    $(".sp-mobile .sp-cart").removeClass("on");
                }, 500);
            } else {
                $(".sp-pc .sp-header-top .sp-cart .num").show();
                $(".sp-pc .sp-header-top .sp-cart").addClass("on");
                setTimeout(function () {
                    $(".sp-pc .sp-header-top .sp-cart").removeClass("on");
                }, 500);
            }
            setTimeout(function () {
                $(".cart-btn").children("img").removeClass("on");
            }, 500);
        });

        let initNum = 0;


    });
    // 倒计时
    function getRandomNum(min, max) {
        return Math.floor(Math.random() * (max - min)) + min
    }

    let endTimeG

    function cutDownTime() {
        let nowTime = new Date()
        let endTime = new Date(endTimeG)

        let leftTime = endTime.getTime() - nowTime.getTime()
        if (leftTime < 0) {
            setupNewCountdown()
            leftTime = 0
        }
        let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
            leftM = Math.floor((leftTime / (1000 * 60)) % 60),
            leftS = Math.floor((leftTime / 1000) % 60)
        leftH = leftH >= 10 ? leftH : '0' + leftH
        leftM = leftM >= 10 ? leftM : '0' + leftM
        leftS = leftS >= 10 ? leftS : '0' + leftS

        return {
            hour: leftH,
            minute: leftM,
            second: leftS,
        }
    }
    function setupNewCountdown() {
        const randomHour = getRandomNum(1, 9)
        const currentTime = new Date()
        endTimeG = currentTime.setHours(currentTime.getHours() + randomHour)
    }
    let intervalId

    function getCutDownTime() {
        setupNewCountdown()
        if (intervalId) clearInterval(intervalId)
        intervalId = setInterval(function () {
            let cutDownTimeText = cutDownTime()
            $('.sp_top_cut_down .sp_left_view .sp_hour').html(cutDownTimeText.hour)
            $('.sp_top_cut_down .sp_left_view .sp_minute').html(
                cutDownTimeText.minute
            )
            $('.sp_top_cut_down .sp_left_view .sp_second').html(
                cutDownTimeText.second
            )
        }, 1000)
    }

    getCutDownTime()

    new Swiper('.sp-swiper-fade-top', {
        spaceBetween: 10,
        effect: 'fade',
        autoplay: true,
        autoplay: {
            disableOnInteraction: false,
            delay: 2000,
        },
        speed: 2000,
    })

    // 按钮轮播
    new Swiper('.sp-bg-loop', {
        autoplay: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
            reverseDirection: false,
        },
        loop: true,
    })
    new Swiper('.sp-bg-loop-m', {
        autoplay: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
            reverseDirection: false,
        },
        loop: true,
    })
    new Swiper('.sp-swiper1', {
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
            reverseDirection: false,
        },
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    })
    new Swiper('.sp-swiper1-m', {
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
            reverseDirection: false,
        },
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    })
    new Swiper('.sp-swiper2', {
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
            reverseDirection: false,
        },
        loop: true,
    })
    new Swiper('.sp-swiper2-m', {
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
            reverseDirection: false,
        },
        loop: true,
    })
    new Swiper('.sp-swiper3', {
        slideShadows: true,
        slidesPerView: 'auto',
        spaceBetween: 40,
        centeredSlides: true,
        loop: true, //循环滚动
        freeMode: true,
        speed: 6500, //匀速时间
        autoplay: {
            delay: 0,
            stopOnLastSlide: false,
            disableOnInteraction: false,
        },
    })
    jQuery('.sp-scroll2').slide({
        mainCell: '.nav-imgs',
        autoPlay: true,
        effect: 'leftMarquee',
        interTime: 12,
        vis: 1,
        scroll: 1,
    })

    let _swiper = new Swiper('.sp-swiper-pro', {
        speed: 1,
        spaceBetween: 0,
    })

    function mainRender() {
        $(function () {
            $('#root').css('zoom', 'normal')
            if (document.body.clientWidth <= 1080) {
                let scale = document.body.clientWidth / 1080
                $('#root').css('zoom', scale)
            } else {
                const scale = document.body.clientWidth / 1920
                $('#root').css('zoom', scale)
            }

            window.addEventListener(
                'resize',
                (function () {
                    var timer
                    return function () {
                        if (timer) clearTimeout(timer)
                        timer = setTimeout(function () {
                            $('#root').css('zoom', 'normal')
                            if (document.body.clientWidth <= 1080) {
                                let scale = document.body.clientWidth / 1080
                                $('#root').css('zoom', scale)
                            } else {
                                const scale = document.body.clientWidth / 1920
                                $('#root').css('zoom', scale)
                            }
                        }, 100)
                    }
                })()
            )
        })

        function lazyLoadImages() {
            // 懒加载
            const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
            const config = {
                rootMargin: '0px 0px 1300px 0px',
                threshold: 0,
            }

            const lazyLoadObserver = new IntersectionObserver(function (
                entries,
                observer
            ) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        // 当图片进入视口时
                        const image = entry.target
                        const dataSrc = image.getAttribute('data-src')
                        image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
                        lazyLoadObserver.unobserve(image) // 停止观察该图片
                    }
                })
            },
                config)

            images.forEach(function (image) {
                lazyLoadObserver.observe(image) // 开始观察每个图片
            })
        }

        function preloadImages(imageArray) {
            // 预加载
            // 检查数组数据结构
            if (Array.isArray(imageArray[0])) {
                // 处理二维数组
                imageArray.forEach(subArray => {
                    subArray.forEach(url => {
                        const img = new Image()
                        img.src = url
                    })
                })
            } else {
                // 处理一维数组
                imageArray.forEach(url => {
                    const img = new Image()
                    img.src = url
                })
            }
        }

        lazyLoadImages()

        preloadImages(spImgList)

        var links = document.querySelectorAll('a[href^="#shopping"]')
        links.forEach(function (link) {
            link.addEventListener('click', function (event) {
                event.preventDefault() // 阻止默认的跳转行为

                // 方式一
                const targetElement = document.getElementById('shopping') // 获取跳转目标节点
                const offsetTop =
                    document.body.clientWidth <= 1080
                        ? targetElement.offsetTop
                        : targetElement.offsetTop - 46
                let sptop = document.body.clientWidth <= 1080 ? 60 : 90

                window.scroll({
                    top:
                        offsetTop * $('div#root').css('zoom') -
                        sptop * $('div#root').css('zoom'),
                    behavior: 'smooth', // 使用 smooth 实现平滑滚动
                })
            })
        })

        // IOS字体多了间距的处理 给节点添加 sp_system 类名
        // 判断当前用户是安卓端还是iOS端
        var userAgent = navigator.userAgent || navigator.vendor || window.opera
        var isAndroid = /android/i.test(userAgent)
        var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
        var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

        if (isAndroid) {
            console.log('Android')
        } else if (isIOS) {
            console.log('iOS')
        } else if (isPC) {
            console.log('PC')
        } else {
            $('.sp_system').css('letter-spacing', '-4px')
        }
    }

    mainRender()

    // 标题文本渐出
    const graduallyList = document.getElementsByClassName('gradually')
    for (let gradually of graduallyList) {
        const spans = gradually.querySelectorAll('span')
        const paragraph = gradually.querySelector('.sp-sub-title')

        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        // 给每个 span 和 i 动画
                        spans.forEach((span, index) => {
                            span.style.animation = `swift-up-fade 0.5s ease forwards`
                            span.style.animationDelay = `${index * 0.1}s`

                            const i = span.querySelector('i')
                            if (i) {
                                i.style.animation = `swift-up-fade 0.5s ease forwards`
                                i.style.animationDelay = `${index * 0.1}s`
                            }
                        })

                        // 段落
                        const totalDelay = spans.length * 0.1 + 0.3
                        if (paragraph) {
                            paragraph.style.animation = `swift-up-fade 0.5s ease forwards`
                            paragraph.style.animationDelay = `${totalDelay}s`
                        }

                        observer.unobserve(gradually)
                    }
                })
            },
            {
                threshold: 0.3,
            }
        )
        observer.observe(gradually)
    }

    // // 点击按钮
    // $(".sp-video-btn").click(function () {
    //   $(".sp-mask").css("display", "flex");
    // });

    // 菜单
    $('.sp-menu-btn').click(function (e) {
        $('.sp-menu-mask').show()
    })

    $('.sp-menu-mask').click(function (e) {
        // if ($(e.target).closest(".sp-menu-mask li").length > 0) {
        // } else {
        $('.sp-menu-mask').hide()
        // }
    })

    // 滚动隐藏顶部
    if (
        $(window).scrollTop() >
        $('.sp_header').height() * $('div#root').css('zoom')
    ) {
        $('.sp_header-wrap').addClass('sp-fixed')
    } else {
        $('.sp_header-wrap').removeClass('sp-fixed')
    }

    let spTimer = null
    let spHasShown = false // 防止重复显示

    $(window).scroll(function () {
        if (
            $(window).scrollTop() >
            $('.sp_header').height() * $('div#root').css('zoom')
        ) {
            $('.sp_header-wrap').addClass('sp-fixed')
        } else {
            $('.sp_header-wrap').removeClass('sp-fixed')
        }

        // 滚动添加底部
        if (spHasShown) return // 已经显示就不再触发

        // 如果没有定时器，则开始计时
        if (!spTimer && $(window).scrollTop() > 800) {
            spTimer = setTimeout(function () {
                document.querySelector('.sp-btn-style2').style.display = 'flex'
                spHasShown = true // 标记为已显示
            }, 3000)
        }
    })

    $(document).on('click', '.sp_buy_now', function () {
        // console.log('xxx111')

        let num = $('#calcNumber').val()
        window.location.href = '/cart/' + getCur().id + ':' + num
    })
    console.log(22222333)
    // 弹窗 start
    var main_id = "";
    $('.emitCheckout').click(function () {
        console.log('1111')
        main_id = getCur().id
        // main_id = $(this).siblings('.select_span').find('span.on').data('id')
        // window.location.href = "/cart/" + id + ":1"
    })

    function getPopProdId() {
        let selectVals = [];
        $('.overbuy_wrap .sp-subopt.active').each(function () {
            selectVals.push($(this).data('val'))
        })

        let cur = popProduct.filter(item => {
            let option1 = selectVals[0];
            let option2 = null;
            let option3 = null;
            if (selectVals[1]) {
                option2 = selectVals[1];
            }
            if (selectVals[2]) {
                option3 = selectVals[2];
            }


            return item.option1 == option1 && item.option2 == option2 && item.option3 == option3
        })



        return cur[0];
    }

    $('.overbuy-select div').click(function () {
        $(this).siblings().removeClass('active')
        $(this).addClass('active')
        let cur = getPopProdId();

        if (cur) {
            $(".main-btn").text('GET 10% oFF').removeClass("overbuy_disabled")
            let _price = parseFloat(cur.price / 100).toFixed(2);
            let _compare_at_price = parseFloat(cur.compare_at_price / 100).toFixed(2);

            $('.overbuy_price span').eq(0).html('£' + _price);
            $('.overbuy_price span').eq(1).html('£' + _compare_at_price);
        } else {
            $(".main-btn").text("Unavailable").addClass("overbuy_disabled")
        }

    })




    window.emitSubmit = function (_type) {
        let num = $('#calcNumber').val()
        if (_type == 'all') {
            // var bundle_sku = data[$('input[name="overbuy1"]:checked').val()][$('input[name="overbuy2"]:checked').val()]
            let _id = getPopProdId()?.id;
            if (!_id) return
            console.log(_id)

            window.location.href = `/cart/${main_id}:${num},${_id}:1`
        } else {
            window.location.href = `/cart/${main_id}:${num}`
        }
    }



    // 弹窗 end

    let initNum = 0

    // 问答
    $('.sp-qa2-question').on('click', function () {
        var $currentItem = $(this).closest('.sp-qa2-item')
        var $answer = $currentItem.find('.sp-qa2-answer')

        // 如果当前项已经打开 -> 关闭它
        if ($currentItem.hasClass('active')) {
            $answer.slideUp(300)
            $currentItem.removeClass('active')
        }
        // 如果当前项是关闭的 -> 开启它 (并关闭其他项)
        else {
            // 关闭其他所有项
            $('.sp-qa2-item').removeClass('active')
            $('.sp-qa2-answer').slideUp(300)

            // 开启当前项
            $currentItem.addClass('active')
            $answer.slideDown(300)
        }
    })

    // 文本渐出动画
    const graduallyList2 = document.getElementsByClassName('sp-fade-box')
    for (let gradually2 of graduallyList2) {
        const paragraph2 = gradually2.querySelectorAll('.sp-ani')

        const observerAni = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        paragraph2.forEach((span, index) => {
                            span.style.animation = `sp-fade-in 1s ease forwards`
                            span.style.animationDelay = `${index * 0.5 + 0.5}s`
                        })

                        observerAni.unobserve(gradually2)
                    }
                })
            },
            {
                threshold: 0.3,
            }
        )
        observerAni.observe(gradually2)
    }
    // 文本渐出动画
    const graduallyList3 = document.getElementsByClassName('sp-fade-box2')
    for (let gradually3 of graduallyList3) {
        const paragraph3 = gradually3.querySelectorAll('.sp-ani2')

        const observerAni = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        paragraph3.forEach((span, index) => {
                            span.style.animation = `sp-fade-left 1s ease forwards`
                            span.style.animationDelay = `${index * 0.3 + 1}s`
                        })

                        observerAni.unobserve(gradually3)
                    }
                })
            },
            {
                threshold: 0.3,
            }
        )
        observerAni.observe(gradually3)
    }
    // 视频进入视口时自动播放
    const videos = document.querySelectorAll('.sp-video')
    const videoObserver = new IntersectionObserver(
        entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // 视频进入视口时播放
                    entry.target.play().catch(error => {
                        // 如果自动播放失败（比如用户设置了阻止自动播放），静默处理
                        console.log('视频自动播放失败:', error)
                        document.addEventListener("DOMContentLoaded", function () {
                            // 倒计时
                            function getRandomNum(min, max) {
                                return Math.floor(Math.random() * (max - min)) + min;
                            }

                            let endTimeG;

                            function cutDownTime() {
                                let nowTime = new Date();
                                let endTime = new Date(endTimeG);

                                let leftTime = endTime.getTime() - nowTime.getTime();
                                if (leftTime < 0) {
                                    setupNewCountdown();
                                    leftTime = 0;
                                }
                                let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
                                    leftM = Math.floor((leftTime / (1000 * 60)) % 60),
                                    leftS = Math.floor((leftTime / 1000) % 60);
                                leftH = leftH >= 10 ? leftH : "0" + leftH;
                                leftM = leftM >= 10 ? leftM : "0" + leftM;
                                leftS = leftS >= 10 ? leftS : "0" + leftS;

                                return {
                                    hour: leftH,
                                    minute: leftM,
                                    second: leftS,
                                };
                            }
                            function setupNewCountdown() {
                                const randomHour = getRandomNum(1, 9);
                                const currentTime = new Date();
                                endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
                            }
                            let intervalId;

                            function getCutDownTime() {
                                setupNewCountdown();
                                if (intervalId) clearInterval(intervalId);
                                intervalId = setInterval(function () {
                                    let cutDownTimeText = cutDownTime();
                                    $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
                                    $(".sp_top_cut_down .sp_left_view .sp_minute").html(
                                        cutDownTimeText.minute
                                    );
                                    $(".sp_top_cut_down .sp_left_view .sp_second").html(
                                        cutDownTimeText.second
                                    );
                                }, 1000);
                            }

                            getCutDownTime();

                            new WOW().init();

                            jQuery(".sp-scroll").slide({
                                mainCell: ".nav-imgs",
                                autoPlay: true,
                                effect: "leftMarquee",
                                interTime: 12,
                                vis: 1,
                                scroll: 1,
                            });

                            new Swiper('.mySwiper', {
                                slidesPerView: 'auto',
                                spaceBetween: 35,
                                loop: true, //循环滚动
                                freeMode: true,
                                speed: 6500, //匀速时间
                                autoplay: {
                                    delay: 0,
                                    stopOnLastSlide: false,
                                    disableOnInteraction: true,
                                },
                                allowTouchMove: false,
                            })

                            new Swiper(".sp-swiper1", {
                                autoplay: true,
                                autoplay: {
                                    delay: 3500,
                                    disableOnInteraction: false,
                                },
                                slideShadows: true,
                                slidesPerView: "auto",
                                spaceBetween: 0,
                                centeredSlides: true,
                                loop: true,
                            });
                            new Swiper(".sp-swiper2", {
                                autoplay: true,
                                autoplay: {
                                    delay: 3500,
                                    disableOnInteraction: false,
                                },
                                slideShadows: true,
                                slidesPerView: "auto",
                                spaceBetween: 0,
                                centeredSlides: true,
                                loop: true,
                            });

                            new Swiper(".sp-brands-slider", {
                                spaceBetween: 0,
                                loop: true,
                                autoplay: {
                                    delay: 0,
                                    disableOnInteraction: false,
                                },
                                speed: 3000,
                                slidesPerView: "auto",
                                freeMode: true,
                            });

                            new Swiper(".sp-swiper3", {
                                autoplay: true,
                                autoplay: {
                                    delay: 3500,
                                    disableOnInteraction: false,
                                },
                                slideShadows: true,
                                slidesPerView: "auto",
                                spaceBetween: 0,
                                centeredSlides: true,
                                loop: true,
                                pagination: {
                                    el: ".swiper-pagination",
                                    clickable: true
                                },
                                on: {
                                    slideChange: function () {
                                        const activeIndex = this.activeIndex; // 或 this.realIndex
                                        const bullets = document.querySelectorAll('.sp-pagination1 .swiper-pagination-bullet');

                                        // 先清空所有 swiper-pagination-bullet2
                                        bullets.forEach(b => b.classList.remove('swiper-pagination-bullet2'));

                                        // 根据当前索引添加类名
                                        if ([3, 6].includes(activeIndex)) {
                                            bullets[1]?.classList.add('swiper-pagination-bullet2');
                                        } else if (activeIndex === 4) {
                                            bullets[0]?.classList.add('swiper-pagination-bullet2');
                                        } else if (activeIndex === 5) {
                                            bullets[1]?.classList.add('swiper-pagination-bullet2');
                                        }
                                    }
                                }
                            });

                            new Swiper(".sp-swiper-fade", {
                                spaceBetween: 10,
                                effect: "fade",
                                autoplay: true,
                                autoplay: {
                                    disableOnInteraction: false,
                                    delay: 2000,
                                },
                                speed: 2000,
                            });

                            new Swiper(".sp-swiper-fade1", {
                                autoplay: true,
                                autoplay: {
                                    disableOnInteraction: false,
                                },
                                spaceBetween: 10,
                                loop: true,
                                on: {
                                    slideChange: function (e) {
                                        e.slides.find(".sp-text").each(function () {
                                            this.style.animation = "none";
                                        });
                                        const spText = e.slides.eq(e.activeIndex).find(".sp-text")[0];
                                        if (spText) {
                                            spText.style.animation = "none";

                                            spText.style.animation = `swiper-up-fade 0.5s ease forwards`;
                                        }
                                    },
                                },
                            });

                            new Swiper(".sp-swiper0", {
                                autoplay: true,
                                autoplay: {
                                    disableOnInteraction: false,
                                },
                                spaceBetween: 10,
                                loop: true,
                            });

                            function mainRender() {
                                $(function () {
                                    $("#root").css("zoom", "normal");
                                    if (document.body.clientWidth <= 1060) {
                                        let scale = document.body.clientWidth / 1080;
                                        $("#root").css("zoom", scale);
                                    } else {
                                        const scale = document.body.clientWidth / 1920;
                                        $("#root").css("zoom", scale);
                                    }

                                    window.addEventListener(
                                        "resize",
                                        (function () {
                                            var timer;
                                            return function () {
                                                if (timer) clearTimeout(timer);
                                                timer = setTimeout(function () {
                                                    $("#root").css("zoom", "normal");
                                                    if (document.body.clientWidth <= 1060) {
                                                        let scale = document.body.clientWidth / 1080;
                                                        $("#root").css("zoom", scale);
                                                    } else {
                                                        const scale = document.body.clientWidth / 1920;
                                                        $("#root").css("zoom", scale);
                                                    }
                                                }, 100);
                                            };
                                        })()
                                    );
                                });

                                function lazyLoadImages() {
                                    // 懒加载
                                    const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
                                    const config = {
                                        rootMargin: "0px 0px 1300px 0px",
                                        threshold: 0,
                                    };

                                    const lazyLoadObserver = new IntersectionObserver(function (
                                        entries,
                                        observer
                                    ) {
                                        entries.forEach(function (entry) {
                                            if (entry.isIntersecting) {
                                                // 当图片进入视口时
                                                const image = entry.target;
                                                const dataSrc = image.getAttribute("data-src");
                                                if (dataSrc) {
                                                    image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
                                                }
                                                lazyLoadObserver.unobserve(image); // 停止观察该图片
                                            }
                                        });
                                    },
                                        config);

                                    images.forEach(function (image) {
                                        lazyLoadObserver.observe(image); // 开始观察每个图片
                                    });
                                }

                                function preloadImages(imageArray) {
                                    // 预加载
                                    // 检查数组数据结构
                                    if (Array.isArray(imageArray[0])) {
                                        // 处理二维数组
                                        imageArray.forEach((subArray) => {
                                            subArray.forEach((url) => {
                                                const img = new Image();
                                                img.src = url;
                                            });
                                        });
                                    } else {
                                        // 处理一维数组
                                        imageArray.forEach((url) => {
                                            const img = new Image();
                                            img.src = url;
                                        });
                                    }
                                }

                                lazyLoadImages();

                                // let imgList = [
                                //     'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/blue.png?v=1774613383',
                                //     'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/green.png?v=1774613383',
                                //     'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/blue-head.png?v=1774613969',
                                //     'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/green-head.png?v=1774613968'
                                // ];

                                // 预加载所有可能的图片组合
                                // for (let c = 1; c <= colorCount; c++) {
                                //     for (let q = 1; q <= qtyCount; q++) {
                                //         for (let p = 1; p <= proCount; p++) {
                                //             imgList.push(`https://cdn.shopify.com/s/files/1/0622/2734/9558/files/20260312-${c}-${q}-${p}.png`);
                                //         }
                                //     }
                                // }
                                // 预加载所有图片
                                preloadImages(imgList);

                                // 更新主图显示
                                function updateMainImage() {
                                    // 重新获取当前选中的索引
                                    let colorIndex = $("#sp-color .sp-option.active").index();
                                    let qtyIndex = $("#sp-qty .sp-option.active").index();
                                    // let proIndex = $("#sp-pro .sp-option.active").index() + 1;
                                    // 更新图片
                                    $(".sp-img-m").attr('src', imgList[colorIndex + qtyIndex * 4]);
                                }

                                // 初始化图片
                                updateMainImage();

                                // IOS字体多了间距的处理
                                var userAgent = navigator.userAgent || navigator.vendor || window.opera;
                                var isAndroid = /android/i.test(userAgent);
                                var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
                                var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent);

                                if (!isAndroid && !isIOS && !isPC) {
                                    $(".sp_system").css("letter-spacing", "-4px");
                                }
                            }

                            mainRender();

                            // 找到所有跳转套餐的锚点链接 - 使用事件委托确保所有链接都能工作
                            function handleShoppingLinkClick(event) {
                                const link = event.target.closest('a[href="#shopping"]');
                                if (!link) return;

                                event.preventDefault();

                                const targetElement = document.getElementById("shopping");
                                if (targetElement) {
                                    const offsetTop = targetElement.offsetTop;
                                    let sptop = document.body.clientWidth <= 1080 ? 0 : 110;
                                    let zoomValue = parseFloat($("div#root").css("zoom")) || 1;
                                    const scrollTop = offsetTop * zoomValue - sptop * zoomValue;

                                    window.scrollTo({
                                        top: scrollTop,
                                        behavior: "smooth",
                                    });

                                    setTimeout(() => {
                                        if (window.pageYOffset === 0 || Math.abs(window.pageYOffset - scrollTop) > 100) {
                                            $('html, body').animate({
                                                scrollTop: scrollTop
                                            }, 800);
                                        }
                                    }, 100);
                                }
                            }

                            // 使用事件委托在document上监听所有点击
                            document.addEventListener('click', handleShoppingLinkClick);

                            let sp_price1 = 9.99;
                            let sp_price2 = 19.89;

                            function calcTotal(price, num) {
                                let result = Number(price) * Number(num);
                                return result.toFixed(2);
                            }

                            let prods = window.product
                            function getCur() {
                                let color = $('#sp-color div.active').attr('data-val')
                                let qty = $('#sp-qty div.active').attr('data-val')
                                let pro = $('#sp-pro div.active').attr('data-val')
                                return prods.filter(
                                    item => item.option1 == color
                                        && item.option2 == qty
                                    && item.option3 == pro
                                )[0]
                            }
                            function changePrice() {
                                let num = $('#calcNumber').val()
                                let price = ((getCur().price * num) / 100).toFixed(2)
                                let compare = ((getCur().compare_at_price * num) / 100).toFixed(2)
                                // price = (price + '').replace('.', ',')
                                // compare = (compare + '').replace('.', ',')
                                $('#sp_price1').html(price)
                                $('#sp_price2').html(compare)
                                let off_font =
                                    100 - Math.ceil((getCur().price / getCur().compare_at_price) * 100)
                                $('.price-group .font-off').html(off_font)
                            }
                            $('.sp-btn-style').click(function () {
                                let num = $('#calcNumber').val()
                                let id = getCur().id
                                window.location.href = '/cart/' + id + ':' + num
                            })
                            $(".sp-reduce").click(function () {
                                let input = $(this).siblings("input")[0];
                                let num = Number(input.value) - 1;
                                if (num > 0) {
                                    input.value = num;
                                }
                                changePrice()
                            });
                            $(".sp-add").click(function () {
                                let input = $(this).siblings("input")[0];
                                let num = Number(input.value) + 1;
                                input.value = num;
                                changePrice()
                            });
                            $(".addCart").click(function () {
                                console.log(2222)

                            });
                            // 标题文本渐出
                            const graduallyList = document.getElementsByClassName("gradually");
                            for (let gradually of graduallyList) {
                                const spans = gradually.querySelectorAll("span, div");
                                const paragraph = gradually.querySelector(".sp-sub-title");

                                const observer = new IntersectionObserver(
                                    (entries) => {
                                        entries.forEach((entry) => {
                                            if (entry.isIntersecting) {
                                                // 给每个 span/div 和 i 动画
                                                spans.forEach((span, index) => {
                                                    span.style.animation = `swift-up-fade 0.5s ease forwards`;
                                                    span.style.animationDelay = `${index * 0.1}s`;

                                                    const i = span.querySelector("i");
                                                    if (i) {
                                                        i.style.animation = `swift-up-fade 0.5s ease forwards`;
                                                        i.style.animationDelay = `${index * 0.1}s`;
                                                    }
                                                });

                                                // 段落
                                                const totalDelay = spans.length * 0.1 + 0.3;
                                                if (paragraph) {
                                                    paragraph.style.animation = `swift-up-fade2 0.5s ease forwards`;
                                                    paragraph.style.animationDelay = `${totalDelay}s`;
                                                }

                                                observer.unobserve(gradually);
                                            }
                                        });
                                    },
                                    {
                                        threshold: 0.3,
                                    }
                                );
                                observer.observe(gradually);
                            }

                            // 菜单
                            $(".sp-menu-btn").click(function (e) {
                                $(".sp-menu-mask").show();
                            });

                            $(".sp-menu-mask").click(function (e) {
                                $(".sp-menu-mask").hide();
                            });

                            function getZoomValue() {
                                let zoom = $("div#root").css("zoom");
                                return parseFloat(zoom) || 1;
                            }

                            function handleScroll() {
                                // let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
                                // let zoomValue = getZoomValue();
                                // let headerHeight = $(".header:visible").height() * zoomValue;

                                // if (scrollTop > headerHeight) {
                                //   $(".sp-pc .sp-header-top").addClass("sp-fixed");
                                // } else {
                                //   $(".sp-pc .sp-header-top").removeClass("sp-fixed");
                                // }
                            }

                            // 初始检查
                            handleScroll();

                            // 监听多种滚动事件
                            window.addEventListener('scroll', handleScroll, true);
                            document.addEventListener('scroll', handleScroll, true);



                            // 问答
                            $(".q-row").click(function () {
                                $(this).parent().toggleClass("sp-show");
                            });

                            // 文本渐出动画
                            const graduallyList2 = document.getElementsByClassName("sp-fade-box");
                            for (let gradually2 of graduallyList2) {
                                const paragraph2 = gradually2.querySelectorAll(".sp-ani");

                                const observerAni = new IntersectionObserver(
                                    (entries) => {
                                        entries.forEach((entry) => {
                                            if (entry.isIntersecting) {
                                                paragraph2.forEach((span, index) => {
                                                    span.style.animation = `sp-fade-in 1s ease forwards`;
                                                    span.style.animationDelay = `${index * 0.5 + 0.5}s`;
                                                });

                                                observerAni.unobserve(gradually2);
                                            }
                                        });
                                    },
                                    {
                                        threshold: 0.3,
                                    }
                                );
                                observerAni.observe(gradually2);
                            }
                            // 文本渐出动画
                            const graduallyList3 = document.getElementsByClassName("sp-fade-box2");
                            for (let gradually3 of graduallyList3) {
                                const paragraph3 = gradually3.querySelectorAll(".sp-ani2");

                                const observerAni = new IntersectionObserver(
                                    (entries) => {
                                        entries.forEach((entry) => {
                                            if (entry.isIntersecting) {
                                                paragraph3.forEach((span, index) => {
                                                    span.style.animation = `sp-fade-left 1s ease forwards`;
                                                    span.style.animationDelay = `${index * 0.3 + 1}s`;
                                                });

                                                observerAni.unobserve(gradually3);
                                            }
                                        });
                                    },
                                    {
                                        threshold: 0.3,
                                    }
                                );
                                observerAni.observe(gradually3);
                            }
                        });
                    })
                } else {
                    // 视频离开视口时暂停
                    entry.target.pause()
                }
            })
        },
        {
            threshold: 0.3, // 当视频30%可见时触发
        }
    )

    videos.forEach(video => {
        videoObserver.observe(video)
    })
})
